export const GZ_TITLE_ID_SELECTOR = 'gz-title-view-name';
export const SAVE_BUTTON_ID = 'save-button';
export const SAVE_AS_BUTTON_ID = 'save-as-button';
export const DISCARD_BUTTON_ID = 'discard-button';

export enum SmartViewToolbarState {
  DEFAULT = 0,
  UNSAVED_CHANGES = 1,
}

export enum SmartViewButtonEvents {
  SAVE = 'save',
  SAVE_AS = 'saveAs',
  DISCARD = 'discard',
}
